import { render } from "./Drone.vue?vue&type=template&id=0d97a974&scoped=true"
import script from "./Drone.vue?vue&type=script&lang=js"
export * from "./Drone.vue?vue&type=script&lang=js"

import "./Drone.vue?vue&type=style&index=0&id=0d97a974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d97a974"]])

export default __exports__